"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var token_distribution_1 = require("./token-distribution/token-distribution");
exports.findPlaceholderPositions = token_distribution_1.findPlaceholderPositions;
exports.replaceContactFieldsByMap = token_distribution_1.replaceContactFieldsByMap;
exports.clearTokenMeta = token_distribution_1.clearTokenMeta;
var version_converter_1 = require("./version-converter/version-converter");
exports.convertV2ToV3Token = version_converter_1.convertV2ToV3Token;
exports.convertV3ToV2Token = version_converter_1.convertV3ToV2Token;
exports.convertV3ToV1Token = version_converter_1.convertV3ToV1Token;
exports.convertV1ToV3Token = version_converter_1.convertV1ToV3Token;
var utils_1 = require("./utils/utils");
exports.surroundPlaceholders = utils_1.surroundPlaceholders;
exports.isCloudPersRequired = utils_1.isCloudPersRequired;
//# sourceMappingURL=index.js.map